import { ISearchPage } from "@/types/AppTypes";

//详情
export interface IDtpDetail {
    id: string,
    shopCode?: string,  //;
    //门店名称
    shopName?: string,  //;
    //业务编码
    code: string,  //;
    customsCode?: string,  //;
    //关联编码
    relevanceOrderId?: string,  //;
    //预录编号（报关单号）
    prescoCode?: string,  //;
    //外贸合同号
    saleCode?: string,  //;
    //境内发货人编码
    supplierCode?: string,  //;
    //境内发货人名称
    supplierName?: string,  //;
    //境外收货人编码
    customerCode?: string,  //;
    //境外收货人名称
    customerName?: string,  //;
    //出境关别
    exitType?: string,  //;
    //运输方式
    shipmentType?: string,  //;
    //出口日期
    departureTime?: moment.Moment | null | string,  //;
    //申报日期
    declareTime?: moment.Moment | null | string,  //;
    //监管方式
    supervisionMethod?: string,  //;
    //征免性质
    exemptionType?: string,  //;
    //许可证号
    licenseKey?: string,  //;
    //提运单号
    deliveryNumber?: string|null,  //;
    //贸易国
    countryTrade?: string,  //;
    //运抵国
    destinationCountry?: string,  //;
    //指运港（卸货港）
    dischargingPort?: string,  //;
    //离境口岸
    portDeparture?: string,  //;
    //运输输工具名称及航次号
    voyageNumber?: string,  //;
    //成交方式
    transactionType?: string,  //;
    //包装种类
    packageType?: string,  //;
    //件数
    num?: string | number,  //;
    //毛重量
    roughWeight?: string | number,  //;
    //净重量
    suttle?: string | number,  //;
    //体积
    volume?: string | number,  //;
    //运费
    freight?: string | number,  //;
    //保费
    premium?: string | number,  //;
    //杂费
    incidentals?: string | number,  //;
    //单证及编号
    documentsNum?: string,  //;
    //唛码备注
    labelNote?: string,  //;
    //特殊关系确认
    relationshipAffirm?: string,  //;
    //价格确认
    priceAffirm?: string,  //;
    //支付确认
    payAffirm?: string,  //;
    //申报缴纳
    declareType?: string,  //;
    //商业发票号
    invoiceNumber?: string | number,  //;
    //发票日期
    invoiceTime?: moment.Moment | null | string,  //;
    //备案号
    recordVarchar?: string,  //;
    //状态
    status?: string,  //;
    //审批意见
    advise?: string,  //;
    //备注
    note?: string,  //;
    createBills?: string,
    auditFlag?: string,
    address?: string,
    contact?: string,
    email?: string,
    phone?: string,
    "details"?: IDtpMaterialDetail[],
    createTime?: moment.Moment | string | null,
    updateTime?: moment.Moment | string | null,
    updateUser?:string
    [key: string]: any
}

//商品详情
export interface IDtpMaterialDetail {
    key: string,  //自己用
    id?: string,   // "详情id",
    code?: string;
    //物资编码
    materialCode?: string;
    //物资名称
    materialName?: string;
    //物资英文名称
    materialEname?: string;
    //物资类型名称
    typeName?: string;
    //单位
    model?: string;
    unitName?: string;
    //数量
    num?: string | number;
    //单价
    price?: string | number;
    //总价
    amount?: string | number;
    //币种
    currency?: string;
    //境内货源地
    sourceSupply?: string;
    //运抵国
    destinationCountry?: string;
    //征免
    shallBe?: string;
    [key: string]: any
}

//新增
export interface IDtpInsert extends IDtpDetail {

}

//编辑
export interface IDtpUpdate extends IDtpInsert {
    id: string,
}

//搜索条件
export interface IDtpSearchFields {
    "code"?: string,   // "询价单号",
    "customerName"?: string,   // "客户名称",
    "shopCode"?: string,   // "门店Code",
    "status"?: string,   // "状态"
}

export interface IDtpSearch
    extends IDtpSearchFields, ISearchPage {

}


/**
 * 详情
 */
//tab枚举
export enum IDtpTabEnum {
    BASE_DETAIL,  //基础数据
    CUSTOMS_CLEARANCE, //报关单
    INVOICE, //商业发票
    ENCASEMENT, //装箱单
    RELEVANCE_TASK, //关联业务
    FILES,   //附件管理
    AUDIT_DETAIL,//审批明细
}

export interface IPdfType {
    customs_clearance: boolean,
    invoice: boolean,
    encasement: boolean,
}

export interface IAuditPdf {
    code?: 0 | 1,
    //关联编码
    relevanceOrderId?: 0 | 1,
    //预录编号（报关单号）
    prescoCode?: 0 | 1,
    //外贸合同号
    saleCode?: 0 | 1,
    //境内发货人编码
    supplierCode?: 0 | 1,
    //境内发货人名称
    supplierName?: 0 | 1,
    //境外收货人编码
    customerCode?: 0 | 1,
    //境外收货人名称
    customerName?: 0 | 1,
    //出境关别
    exitType?: 0 | 1,
    //运输方式
    shipmentType?: 0 | 1,
    //出口日期
    departureTime?: | 0 | 1,
    //申报日期
    declareTime?: | 0 | 1,
    //监管方式
    supervisionMethod?: 0 | 1,
    //征免性质
    exemptionType?: 0 | 1,
    //许可证号
    licenseKey?: 0 | 1,
    //提运单号
    deliveryNumber?: 0 | 1,
    //贸易国
    countryTrade?: 0 | 1,
    //运抵国
    destinationCountry?: 0 | 1,
    //指运港（卸货港）
    dischargingPort?: 0 | 1,
    //离境口岸
    portDeparture?: 0 | 1,
    //运输输工具名称及航次号
    voyageNumber?: 0 | 1,
    //成交方式
    transactionType?: 0 | 1,
    //包装种类
    packageType?: 0 | 1,
    //件数
    num?: 0 | 1,  //;
    //毛重量
    roughWeight?: 0 | 1,  //;
    //净重量
    suttle?: 0 | 1,  //;
    //体积
    volume?: 0 | 1,  //;
    //运费
    freight?: 0 | 1,  //;
    //保费
    premium?: 0 | 1,  //;
    //杂费
    incidentals?: 0 | 1,  //;
    //单证及编号
    documentsNum?: 0 | 1,
    //唛码备注
    labelNote?: 0 | 1,
    //特殊关系确认
    relationshipAffirm?: 0 | 1,
    //价格确认
    priceAffirm?: 0 | 1,
    //支付确认
    payAffirm?: 0 | 1,
    //申报缴纳
    declareType?: 0 | 1,
    //商业发票号
    invoiceNumber?: 0 | 1,  //;
    //发票日期
    invoiceTime?: 0 | 1,
    //备案号
    recordVarchar?: 0 | 1,
    //状态
    status?: 0 | 1,
    //审批意见
    advise?: 0 | 1,
    //备注
    note?: 0 | 1,
    createBills?: 0 | 1,
    details?: IMaterialAudit[],
    [key: string]: any
}
export interface IMaterialAudit {
    id: 0 | 1
}